import DriverListModal from './DriverListModal';

export default DriverListModal;


// WEBPACK FOOTER //
// ./master/jsx/components/Common/modals/salesOrder/driverList/index.jsx